/**
 * For $.ajax requests
 * $_GP.CSRF_COOKIE is always send
 * If cookie is expired show spop and throw error
 * @example
	$('#select-element').on('change', function(ev) {
		var _this = $(this);
		if (!_this.val()) return;

		vat opt = {
			data: '&val=' + _this.val(),
			type: 'html'
		}

		$_GP.ajax('url/to/api', opt).done(function(resp) {
			// request succeded
		}).fail(function() {
			// request fail
		}).always(function() {
			// request end
		});
	});
 * @param {string} url - endpoint, $.ajax options.url
 * @param {object} options - $.ajax options
 * @param {string} [dataType='json'] - $.ajax dataType
 * @param {string} [type='GET'] - $.ajax type
 * @returns {object} $.ajax request
 * @requires $_GP._.is
 * @requires js.cookie-2.1.2-min.js
 * @requires spop-0.1.2.min.js
**/
function ajax( url, options) {
	if (!url) throw new Error('"url" is required!');

	const defaults = {
		data: null,
		dataType: 'json',
		type: 'GET'
	}
	const opt = $.extend({}, defaults, options)
	opt.url = url

	if (opt.type !== 'GET') {
		const cookieValue = Cookies.get($_GP.CSRF_COOKIE);

		if (!cookieValue) {
			spop({ template: $_GP.msm.submitCookieExpired, style: 'error', group: 'submitCookieExpired'});
			throw new Error('Cookie Expired!');
		}

		if (!(opt.data instanceof FormData)) {
			$('input[name="'+ $_GP.CSRF_TOKEN +'"]').val(cookieValue);

			if ($_GP._.is('string', opt.data)) {
				opt.data = opt.data + '&'+ $_GP.CSRF_TOKEN +'=' + cookieValue;
			} else if ($_GP._.is('object', opt.data)) {
				opt.data[$_GP.CSRF_TOKEN] = cookieValue;
			} else if ($_GP._.is('null', opt.data)) {
				opt.data = '&'+ $_GP.CSRF_TOKEN +'=' + cookieValue;
			} else {
				throw new Error('Invalid "data"!. String, object or null');
			}
		}
	}

	return $.ajax(opt);
}

async function asyncAjax( url, options) {
	if (!url) throw new Error('"url" is required!');

	const defaults = {
		data: null,
		dataType: 'json',
		type: 'GET'
	}

	const opt = $.extend({}, defaults, options)
	opt.url = url

	if (opt.type !== 'GET') {
		const cookieValue = Cookies.get($_GP.CSRF_COOKIE);

		if (!cookieValue) {
			spop({ template: $_GP.msm.submitCookieExpired, style: 'error', group: 'submitCookieExpired'});
			throw new Error('Cookie Expired!');
		}

		if (!(opt.data instanceof FormData)) {
			$('input[name="'+ $_GP.CSRF_TOKEN +'"]').val(cookieValue);

			if ($_GP._.is('string', opt.data)) {
				opt.data = opt.data + '&'+ $_GP.CSRF_TOKEN +'=' + cookieValue;
			} else if ($_GP._.is('object', opt.data)) {
				opt.data[$_GP.CSRF_TOKEN] = cookieValue;
			} else if ($_GP._.is('null', opt.data)) {
				opt.data = '&'+ $_GP.CSRF_TOKEN +'=' + cookieValue;
			} else {
				throw new Error('Invalid "data"!. String, object or null');
			}
		}
	}

	try {
		return await $.ajax(opt);
	} catch (err) {
		spop({template: (opt.submitFailMsm ? opt.submitFailMsm : $_GP.msm.submitFail), style: 'error', group: 'async-ajax' });
	} finally {
		if (opt.finally) opt.finally()
	}
}

/**
 * $.ajax request width $.fn.serialize() for all, valid, inputs
 * @example
	$('#form').on('submit', function(ev) {
		ev.preventDefault();
		var extraData = '&dataNotInSerialize=12345';

		$_GP.ajaxSubmitInner('#form', {
			url: 'url/to/endpoint',
			data: extraData,
			formReset: false,
			done: function(resp) {
				// request succeded and resp.success === true
			},
			$ajax: function($elm, request) {
				// $elm = $('#form')
				// request = $.ajax request
			}
		});

		return false;
	});
 * @param {string|jQuery} elm - form element
 * @param {object} opt - options
 * @property {string} opt.url - endpoint, $.ajax url
 * @property {string|object} [opt.data] - extradata to ben send in $.ajax data
 * @property {string} [opt.dataType='json'] - $.ajax dataType
 * @property {string} [opt.type='POST'] - $.ajax type
 * @property {boolean} [opt.formReset=true] - reset form in done and !!resp.success
 * @property {string} [opt.submitFailMsm=$_GP.msm.submitFail] - fail msm
 * @property {function} [opt.done(resp)] - callback in request done and resp.success is truthy
 *   @param {*} resp - depends in $.ajax response
 * @property {function} [opt.$ajax($elm, request)] - callback
 *   @param {jQuery} $elm - form element
 *   @param {object} request - $.ajax request
 * @returns {object} $.ajax request
 * @requires $_GP.ajax,$_GP.msm.submitFail
**/

function ajaxSubmitInner(elm, opt) {
	if ($_GP.REQUEST_ACTIVE) return
	$_GP.REQUEST_ACTIVE = true

	const $elm = $(elm);

	let OPTIONS = {};

	if ( opt.data instanceof FormData || opt.data === 'multipart/form-data' && opt.processData === false) {
		$('input[name="'+ $_GP.CSRF_TOKEN +'"]').val(Cookies.get($_GP.CSRF_COOKIE));
		OPTIONS.data = new FormData($elm[0])
	} else {
		const serializeWithoutToken = $elm.find('input[name!="'+ $_GP.CSRF_TOKEN +'"], textarea, select').serialize();

		if ($_GP._.is('string', opt.data)) {
			OPTIONS.data = serializeWithoutToken + opt.data;
		} else if ($_GP._.is('object', opt.data)) {
			OPTIONS.data = serializeWithoutToken + '&' + $.param(opt.data);
		} else {
			OPTIONS.data = serializeWithoutToken;
		}
	}

	OPTIONS.type = 'POST'

	const request = $_GP.ajax( opt.url, $.extend({}, opt, OPTIONS));

	const formReset = opt.formReset === false ? false : true;

	$('button[type="submit"]').prop('disabled', true)
	$elm.addClass('op-7 po-e-n').find('.fa-spin').removeClass('hide');

	request.done(function(resp) {
		if (!resp.success) {
			spop({ template: resp.info, style: 'error', group: elm});
			return;
		}

		if (resp.info) spop({ template: resp.info, style: 'success', group: elm, autoclose: 5000 });

		if (formReset) $elm[0].reset();

		if (opt.done) opt.done(resp);

	}).fail(function() {
		spop({template: (opt.submitFailMsm ? opt.submitFailMsm : $_GP.msm.submitFail), style: 'error', group: elm });
	}).always(function() {
		$_GP.REQUEST_ACTIVE = false
		$('button[type="submit"]').prop('disabled', false)
		$elm.removeClass('op-7 po-e-n').find('.fa-spin').addClass('hide');
	});

	if (opt.$ajax) opt.$ajax($elm, request);

	return request;
}

function ajaxSubmit(elm, opt) {
	const submit = function(ev) {
		ev.preventDefault();

		$_GP.ajaxSubmitInner(elm, opt);

		return false;
	};

	$(elm).on('submit', submit);
}

/**
 * Delegate form submition to a method
 * @module $_GP.ajaxDelegate
**/
function ajaxDelegate() {

	/**
	 * Form submition controled by $_GP.privacyControl
	 * @example
		$_GP.ajaxDelegate.privacyControl('#form', {
			url: 'url/to/endpoint'
		});
	 * @param {string|jQuery} form - form element
	 * @param {object} opt - options, $_GP.ajaxSubmitInner options
	 * @returns {undefined}
	 * @requires $_GP.privacyControl, $_GP.ajaxSubmitInner
	 */
	const privacyControl = function(form, opt) {
		form = $(form)
		if (!form.length) return

		if (!form.find('[data-privacy]').length) {
			console.error(`data-privacy in #${form.attr('id')} is required (<input type="hidden" name="txtPrivacy" data-privacy>)!!!`)
			return false
		}

		const modal = $('#modal-privacy');
		let SUBMITING = false;

		form.on('submit', function(ev) {
			ev.preventDefault()
			if (SUBMITING) return

			$_GP.privacyControl.setForm(form)

			if (!$_GP.privacyControl.getPrivacyAgree()) {
				modal.modal('show')
				return false
			}

			if ($_GP.privacyControl.getPrivacyAgree()) {
				SUBMITING = true
				modal.modal('hide');

				ajaxSubmitInner(form, opt).always(function() {
					SUBMITING = false;
					form.find('[data-privacy]').val('');
				});
			}

			return false;
		});
	}

	return { privacyControl }
}

function ajaxCaptchaRequest(elm,url,argOpt) {
	elm = $(elm);
	if (!elm.length) return

	argOpt = argOpt || {}
	const dataOpt = elm.data('opt') || {}

	const opt = $.extend({}, dataOpt, argOpt)

	const ajax = $_GP.ajax(url, {
		data: opt.sendData,
		dataType: 'html',
	});

	ajax.done(function (resp) {
		if (resp) {
			elm.removeClass('d-n');
			elm.find('input').removeAttr('disabled');
			elm.find('img').attr('src', $(resp).attr('src'));
		} else {
			elm.addClass('d-n');
			elm.find('input').attr('disabled', 'disabled');
		}
	});

	return ajax
}

function ajaxCaptcha(url) {
	const container = $('[data-captcha="container"]')
	if (!container.length) return

	let captchas = {}

	container.find('[data-captcha="trigger"]').on('click', function(ev) {
		ajaxCaptchaRequest($(this).closest('[data-captcha="container"]'),url)
	});

	container.each((i,elm)=> {
		elm = $(elm)
		captchas[elm.data('opt').name] = {}
		const ajax = ajaxCaptchaRequest(elm,url)
		captchas[elm.data('opt').name].elm = elm
		captchas[elm.data('opt').name].ajax = ajax
	})

	return captchas
}


export {
	ajax,
	asyncAjax,
	ajaxSubmitInner,
	ajaxSubmit,
	ajaxDelegate,
	ajaxCaptchaRequest,
	ajaxCaptcha
}
